export default __webpack_public_path__ + "static/media/4.46ad768b.JPG";